<script lang="ts">
	interface Props {
		score: number;
		grade: string;
		size?: number;
		stroke?: number;
		label?: string;
	}
	let { score, grade, size = 168, stroke = 12, label = '' }: Props = $props();

	const radius = $derived((size - stroke) / 2);
	const circumference = $derived(2 * Math.PI * radius);
	const offset = $derived(circumference * (1 - Math.max(0, Math.min(100, score)) / 100));

	const color = $derived(
		score >= 90 ? '#3f6212' : score >= 75 ? '#0f766e' : score >= 60 ? '#9a5b06' : '#b3261e'
	);
</script>

<div class="dial" style:--dial-size="{size}px">
	<svg width={size} height={size} viewBox="0 0 {size} {size}" role="img" aria-label="Genel skor {score} / 100, not {grade}">
		<circle
			cx={size / 2}
			cy={size / 2}
			r={radius}
			fill="none"
			stroke="#e5e0d8"
			stroke-width={stroke}
		/>
		<circle
			cx={size / 2}
			cy={size / 2}
			r={radius}
			fill="none"
			stroke={color}
			stroke-width={stroke}
			stroke-linecap="round"
			stroke-dasharray={circumference}
			stroke-dashoffset={offset}
			transform="rotate(-90 {size / 2} {size / 2})"
			class="arc"
		/>
	</svg>
	<div class="dial-center">
		<span class="score" style:color>{score}</span>
		<span class="scale">/ 100</span>
		<span class="grade" style:color>{grade}</span>
		{#if label}<span class="label">{label}</span>{/if}
	</div>
</div>

<style>
	.dial {
		--d: min(var(--dial-size), 38vw);
		position: relative;
		width: var(--d);
		height: var(--d);
		flex: none;
	}
	svg {
		display: block;
		width: 100%;
		height: 100%;
	}
	.arc {
		transition: stroke-dashoffset 0.9s cubic-bezier(0.22, 1, 0.36, 1);
	}
	.dial-center {
		position: absolute;
		inset: 0;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		gap: 0;
	}
	.score {
		font-family: var(--font-display);
		font-size: calc(var(--d) * 0.28);
		line-height: 1;
		letter-spacing: -0.02em;
	}
	.scale {
		font-size: calc(var(--d) * 0.075);
		color: var(--muted);
		margin-top: 2px;
	}
	.grade {
		font-size: calc(var(--d) * 0.1);
		font-weight: 600;
		margin-top: 6px;
		letter-spacing: 0.04em;
	}
	.label {
		font-size: 0.72rem;
		color: var(--muted);
		text-transform: uppercase;
		letter-spacing: 0.08em;
		margin-top: 2px;
	}
</style>
